import { render, staticRenderFns } from "./SmplEditMail.vue?vue&type=template&id=0a2b88ef&scoped=true&"
import script from "./SmplEditMail.vue?vue&type=script&lang=js&"
export * from "./SmplEditMail.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditMail.vue?vue&type=style&index=0&id=0a2b88ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b88ef",
  null
  
)

export default component.exports